import moment from 'moment-timezone';
import React from 'react';

import { FormatDate, useFormatDate } from 'shared/hooks';

interface DateFormatProps {
  date: moment.Moment;
  formattingOptions?: Parameters<FormatDate>[1];
}

export const DateFormat = ({ date, formattingOptions }: DateFormatProps) => {
  const formatDate = useFormatDate();

  return <>{formatDate(date, formattingOptions)}</>;
};
